import { useRouter } from 'next/router';

import type { Seo } from '@sravni/types/lib/seo';

import { useMetadata } from '../store/hooks/metadata';

export const useMetadataByPath = (): Seo => {
  const router = useRouter();
  const metadata = useMetadata(router.asPath.split('?')?.[0]);

  return metadata;
};
